module.exports = __webpack_public_path__ + "img/Liskscan_logo.c3043e96.svg";